import { isCustomizedType, reduce } from "et3-type-guards";
import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import {
  TAdminIssuesCounts,
  TAuditedEventsCount,
  TConfigurationReceipt,
  TEventsCount
} from "../../Types";
import {
  ADMIN_AUDITED_EVENT_COUNTS_DEFAULTS,
  ADMIN_DEFAULT_ISSUES_COUNT,
  ADMIN_EVENT_COUNTS_DEFAULTS,
  CONFIGURATION_RECEIPT_DEFAULTS
} from "../../constants/input-entries-constants";

export const apiCallGetFinalCSRReceipt = async (): Promise<{
  data: {
    eventsCount: TEventsCount;
    auditedEventsCount: TAuditedEventsCount;
    adminIssuesCount: TAdminIssuesCounts;
    configurationReceipt: TConfigurationReceipt;
  };
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    eventsCount: TEventsCount;
    auditedEventsCount: TAuditedEventsCount;
    adminIssuesCount: TAdminIssuesCounts;
    configurationReceipt: TConfigurationReceipt;
  }>(`csr/getCSRFinalReceipt`, {});

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: {
        eventsCount: ADMIN_EVENT_COUNTS_DEFAULTS,
        auditedEventsCount: ADMIN_AUDITED_EVENT_COUNTS_DEFAULTS,
        adminIssuesCount: ADMIN_DEFAULT_ISSUES_COUNT,
        configurationReceipt: CONFIGURATION_RECEIPT_DEFAULTS
      },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {
        eventsCount: ADMIN_EVENT_COUNTS_DEFAULTS,
        auditedEventsCount: ADMIN_AUDITED_EVENT_COUNTS_DEFAULTS,
        adminIssuesCount: ADMIN_DEFAULT_ISSUES_COUNT,
        configurationReceipt: CONFIGURATION_RECEIPT_DEFAULTS
      },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
